var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5383 45.9968H35.4525C35.4525 44.8746 35.4525 37.2621 35.4525 36.06C36.6207 36.3004 37.5383 37.2621 37.5383 38.464V45.9968ZM12.5114 45.9968V43.9933H33.3669V45.9968H12.5114ZM8.33972 38.384C8.33972 37.182 9.2583 36.2204 10.4255 35.9799C10.4255 37.182 10.4255 44.8749 10.4255 45.9166H8.33972V38.384ZM17.3494 34.3774L21.6875 37.4223L19.9356 38.6244L16.8495 34.9382L17.3494 34.3774ZM29.5301 34.3774L29.9465 34.9382L26.8601 38.6244L25.1916 37.4223L29.5301 34.3774ZM32.3657 35.9801H33.4512V41.99H32.3657V35.9801ZM12.5114 41.99V35.9801H13.5957V41.99H12.5114ZM15.6815 41.99V36.6211L19.0179 40.6276C19.3525 41.0283 20.0189 41.1085 20.4362 40.788L23.5232 38.6244L26.5267 40.788C26.9437 41.1085 27.611 41.0283 27.9447 40.6279L30.2808 37.823V41.99H15.6815ZM35.0362 33.9767H31.866L30.6979 32.3741C30.3635 31.8932 29.6969 31.813 29.1953 32.1335L23.5232 36.1403L17.7673 32.1335C17.2667 31.813 16.6825 31.8932 16.3482 32.3739L15.1809 33.9767H10.9262C8.33972 33.9767 6.25391 35.9799 6.25391 38.384V46.9583C6.25391 47.5193 6.75546 48 7.3385 48C8.50668 48 37.0377 48 38.6229 48C39.2069 48 39.7075 47.5193 39.7075 46.9583V38.384C39.6241 35.9799 37.5383 33.9767 35.0362 33.9767Z",
    fill: "url(#paint0_linear_486_1636)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7888 17.7897C36.1225 18.1102 36.7064 18.1903 37.1234 17.9498L40.6275 15.7062C41.1284 15.3855 41.2108 14.7445 40.8778 14.3438C40.5442 13.8631 39.8766 13.783 39.4596 14.1035L36.7064 15.8664L33.7866 12.9815C33.3693 12.5809 32.7017 12.5809 32.2854 12.9815C31.8684 13.3822 31.8684 14.0233 32.2854 14.424L35.7888 17.7897Z",
    fill: "url(#paint1_linear_486_1636)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17053 11.9399C3.76949 11.9399 4.2549 12.4062 4.2549 12.9816C4.25513 13.557 3.76926 14.0233 3.1703 14.0233C2.57158 14.0233 2.08594 13.557 2.08594 12.9816C2.08594 12.4062 2.57157 11.9399 3.17053 11.9399Z",
    fill: "url(#paint2_linear_486_1636)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4283 22.9183C11.0273 22.9183 11.5127 23.3847 11.5127 23.96C11.5129 24.5354 11.0271 25.0018 10.4283 25.0018C9.82939 25.0018 9.34375 24.5354 9.34375 23.96C9.34375 23.3847 9.82939 22.9183 10.4283 22.9183Z",
    fill: "url(#paint3_linear_486_1636)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7098 29.97C41.3088 29.97 41.7935 30.4363 41.7935 31.0117C41.7935 31.587 41.3085 32.0534 40.7096 32.0534C40.1108 32.0534 39.625 31.587 39.625 31.0117C39.6252 30.4363 40.1109 29.97 40.7098 29.97Z",
    fill: "url(#paint4_linear_486_1636)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8824 39.9867C45.4804 39.9867 45.966 40.453 45.966 41.0284C45.9663 41.6038 45.4804 42.0701 44.8824 42.0701C44.2827 42.0701 43.7969 41.6038 43.7969 41.0284C43.7971 40.453 44.2825 39.9867 44.8824 39.9867Z",
    fill: "url(#paint5_linear_486_1636)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7096 0.881531C42.3086 0.881531 42.7935 1.3479 42.7935 1.92327C42.7935 2.49864 42.3086 2.96497 41.7096 2.96497C41.1109 2.96497 40.625 2.49864 40.625 1.92327C40.625 1.3479 41.1106 0.881531 41.7096 0.881531Z",
    fill: "url(#paint6_linear_486_1636)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08457 36.9417C1.68353 36.9417 2.16916 37.408 2.16916 37.9834C2.16916 38.5588 1.68329 39.0251 1.08457 39.0251C0.485613 39.0251 0 38.5588 0 37.9834C0.000234151 37.408 0.485613 36.9417 1.08457 36.9417Z",
    fill: "url(#paint7_linear_486_1636)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1103 15.9467C27.7782 15.9467 29.1135 17.2287 29.1135 18.8315H29.1138C28.3621 18.8315 17.1007 18.8315 16.349 18.8315C14.6814 18.8315 13.2629 17.5494 13.2629 15.8664H26.1103V15.9467ZM15.6824 9.45584C15.6824 5.28877 19.1865 1.92332 23.5239 1.92332C26.6943 1.92332 29.4474 3.68619 30.6987 6.49082C27.8625 8.09359 25.86 10.8181 25.2758 13.9434L17.2676 13.9432C16.183 12.6611 15.6824 11.0586 15.6824 9.45584ZM31.2829 18.8315C31.2829 16.5075 29.6141 14.5844 27.3616 14.0234C27.6953 12.581 28.2793 11.2989 29.1962 10.2572L30.0314 11.0586C30.4487 11.4593 31.115 11.4593 31.5323 11.0586C31.9496 10.6579 31.9493 10.0166 31.5323 9.61595L30.6987 8.8148C32.1165 7.77309 33.7848 7.13185 35.5368 6.89152L35.537 8.0936C35.537 8.65443 36.0374 9.13534 36.6213 9.13534C37.2062 9.13534 37.7059 8.65443 37.7059 8.0936L37.7062 6.89152C39.5417 7.05189 41.1266 7.77309 42.5442 8.8148L41.7106 9.61595C41.2936 10.0166 41.2936 10.6579 41.7106 11.0586C42.1279 11.4593 42.7945 11.4593 43.2125 11.0586L44.0467 10.2572C45.1306 11.5392 45.8813 13.142 46.0489 14.905H44.6307C44.0467 14.905 43.5452 15.3856 43.5452 15.9467C43.5452 16.5075 44.0467 16.9883 44.6307 16.9883H45.8815C45.7144 18.7513 44.9634 20.2738 43.8798 21.6361L43.0455 20.8347C42.6285 20.434 41.96 20.434 41.543 20.8347C41.1269 21.2354 41.1266 21.8766 41.543 22.2773L42.3775 23.0785C41.0433 24.1202 39.3745 24.8414 37.5392 25.0018V23.7997C37.5392 23.2386 37.0386 22.758 36.4546 22.758C35.8706 22.758 35.4534 23.1587 35.4534 23.7197V24.9216C33.9518 24.7612 32.5333 24.2806 31.2827 23.399C31.2829 21.7965 31.2827 19.713 31.2829 18.8315ZM29.1964 26.0435C29.1964 28.9283 26.7776 31.252 23.7742 31.252C20.7717 31.252 18.3522 28.9283 18.3522 26.0435V20.8347H29.1138V26.0435H29.1964ZM16.2666 20.9149V26.1236C16.2666 30.0502 19.6028 33.3357 23.7742 33.3357C27.8625 33.3357 31.2827 30.1303 31.2827 26.1236L31.2829 25.8032C35.537 27.8866 40.959 27.3257 44.5464 23.8799C44.6307 23.7997 44.6307 23.7997 44.7133 23.7197C49.1351 19.3923 49.0515 12.581 44.7133 8.33393C44.6307 8.25374 44.6307 8.25373 44.5464 8.17355C41.2936 5.1286 36.6213 4.24727 32.5333 5.68945C31.0326 2.32399 27.5286 0 23.4405 0C18.0185 0 13.5132 4.24727 13.5132 9.536C13.5132 11.1385 13.9303 12.6612 14.6812 14.0234H12.1783C11.5946 14.0234 11.0938 14.5042 11.0938 15.0653L11.094 16.0268C11.1773 18.5911 13.4299 20.8347 16.2666 20.9149Z",
    fill: "url(#paint8_linear_486_1636)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17039 29.0084C2.58642 29.0084 2.08579 28.5275 2.08579 27.9667C2.08579 27.4056 2.58619 26.925 3.17016 26.925C3.75343 26.9248 4.25475 27.4056 4.25475 27.9667C4.25499 28.5275 3.67077 29.0084 3.17039 29.0084ZM3.17039 25.0017C1.41824 25.0017 0 26.3639 0 28.0466C0.000234151 29.7296 1.41824 31.0918 3.17016 31.0918C4.92231 31.0918 6.25626 29.6494 6.25626 27.9667C6.25626 26.2837 4.83801 25.0017 3.17039 25.0017Z",
    fill: "url(#paint9_linear_486_1636)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75696 3.92653C7.5903 3.92653 8.34123 4.56754 8.34123 5.44911C8.34123 6.33068 7.6746 6.97172 6.75696 6.97172C5.83839 6.97172 5.17175 6.33068 5.17175 5.44911C5.17199 4.56754 5.92174 3.92653 6.75696 3.92653ZM6.75696 8.97495C8.75848 8.97495 10.427 7.37239 10.427 5.44911C10.427 3.52583 8.75825 1.92331 6.75696 1.92331C4.7538 1.92331 3.08594 3.52583 3.08594 5.44911C3.08617 7.37239 4.7538 8.97495 6.75696 8.97495Z",
    fill: "url(#paint10_linear_486_1636)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1636",
    x1: 22.9807,
    y1: 31.9413,
    x2: 22.9807,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1636",
    x1: 36.5252,
    y1: 12.681,
    x2: 36.5252,
    y2: 18.0897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1636",
    x1: 3.17042,
    y1: 11.9399,
    x2: 3.17042,
    y2: 14.0233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1636",
    x1: 10.4282,
    y1: 22.9183,
    x2: 10.4282,
    y2: 25.0018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1636",
    x1: 40.7092,
    y1: 29.97,
    x2: 40.7092,
    y2: 32.0534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1636",
    x1: 44.8815,
    y1: 39.9867,
    x2: 44.8815,
    y2: 42.0701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1636",
    x1: 41.7092,
    y1: 0.881531,
    x2: 41.7092,
    y2: 2.96497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1636",
    x1: 1.08458,
    y1: 36.9417,
    x2: 1.08458,
    y2: 39.0251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1636",
    x1: 29.5461,
    y1: 0,
    x2: 29.5461,
    y2: 33.3357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1636",
    x1: 3.12813,
    y1: 25.0017,
    x2: 3.12813,
    y2: 31.0918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1636",
    x1: 6.75649,
    y1: 1.92331,
    x2: 6.75649,
    y2: 8.97495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.fad3ee4291b2aeb92de4cc767be63094.svg";
export { ForwardRef as ReactComponent };